import {getIdFromHash} from '@netx/core-next/utils/route/getIdFromHash';

export const getCategoryIdFromHash = (hash?: string) =>
	getIdFromHash(hash ?? window.location.hash, /#category\/(\d+)/, true);
